import { ComponentProps, useContext } from 'react';

import { mergeClasses } from '@/utils';

import TableContext from './TableContext';

const TableBody = ({ className, ...props }: ComponentProps<'tbody'>) => {
  const { template } = useContext(TableContext);
  return (
    <tbody
      data-slot="table-body"
      className={mergeClasses(
        '[&_tr:last-child]:border-0 [&_tr]:bg-neutral-0 [&_tr:hover]:!bg-neutral-2',
        template === 'zebra' && '[&_tr:nth-child(even)]:bg-neutral-1',
        className,
      )}
      {...props}
    />
  );
};
export default TableBody;
